import createReactContext from 'create-react-context';
export const FormContext = createReactContext({
    vertical: false,
});
